import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { EventNames, useTracking } from "lib/tracking";
import { BidEntityType } from "lib/types/graphQLEnums";
import { graphql } from "../../../../generated/app-service-gql";
import {
  RemoveBidEntitiesMutation,
  RemoveBidEntitiesMutationVariables,
} from "../../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";
import { updateBidEntityCache } from "./update_cache/updateBidEntityCache";

const REMOVE_BID_ENTITY_MUTATION = graphql(`
  mutation removeBidEntities($id: String!, $entities: BidEntitiesInput!) {
    removeBidEntities(id: $id, entities: $entities) {
      bidId
      bidName
      entityId
      entityType
    }
  }
`);

export function useRemoveBidEntities(
  options?: UseMutationOptions<
    RemoveBidEntitiesMutation,
    unknown,
    RemoveBidEntitiesMutationVariables,
    unknown
  >,
) {
  const { logEvent } = useTracking();
  const queryClient = useQueryClient();

  return useGraphQlMutation(REMOVE_BID_ENTITY_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      const entities = data.removeBidEntities;

      // Update bid entities cache for removal
      await updateBidEntityCache({
        entities,
        isAdding: false,
        queryClient,
      });

      const hasCustomBuyer = variables.entities.entities.some(
        (e) => e.entityType === BidEntityType.CustomOrganisation,
      );

      logEvent(EventNames.bidDataRemoved, {
        "Bid ID": variables.id,
        "Amount of entities": entities.length,
        "Free-text buyer": hasCustomBuyer,
      });

      options?.onSuccess?.(data, variables, context);
    },
  });
}
